<template>
  <aside class="side-panel">
    <div class="panel-card accent">
      <span class="panel-kicker">Session</span>
      <h3>
        <span class="panel-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7h10v10H7Zm-3 5h3m10 0h3M12 4v3m0 10v3"/></svg>
        </span>
        {{ item.name || "Game Ready" }}
      </h3>
      <p>Built for uninterrupted play, with quick controls for relaunching the game or returning to the main library.</p>
    </div>

    <div class="panel-card">
      <button class="panel-action" @click="onReload">
        <span class="button-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12a8 8 0 1 1-2.34-5.66M20 4v6h-6"/></svg>
        </span>
        Reload Game
      </button>
      <button class="panel-action ghost" @click="onBack">
        <span class="button-icon">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10 7 5 12l5 5M6 12h13"/></svg>
        </span>
        Return to Library
      </button>
    </div>

    <div class="panel-card">
      <span class="panel-kicker">Quick notes</span>
      <ul class="panel-list">
        <li>Landscape or larger screens usually deliver the cleanest gameplay framing.</li>
        <li>If a title stalls during load, use Reload to restart the embedded session.</li>
        <li>The site shell has been redesigned without altering the underlying game files.</li>
      </ul>
    </div>
  </aside>
</template>

<script>
export default {
  name: "GameLeft",
  props: {
    item: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  methods: {
    onReload() {
      var frame = document.getElementById("gameFrame")
      if (frame && frame.contentWindow) {
        frame.contentWindow.location.reload(true)
      }
    },
    onBack() {
      this.$router.push({ name: "Main" })
    }
  }
}
</script>

<style scoped>
.side-panel {
  display: grid;
  gap: 16px;
}

.panel-card {
  padding: 18px;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: linear-gradient(180deg, rgba(18, 20, 24, 0.95), rgba(8, 9, 11, 0.98));
  box-shadow: 0 18px 36px rgba(0, 0, 0, 0.24);
}

.panel-card.accent {
  background:
    radial-gradient(circle at top right, rgba(255, 145, 77, 0.18), transparent 34%),
    linear-gradient(180deg, rgba(18, 20, 24, 0.95), rgba(8, 9, 11, 0.98));
}

.panel-kicker {
  display: inline-block;
  margin-bottom: 10px;
  color: rgba(226, 232, 240, 0.65);
  font: 600 11px/1.2 "Courier New", monospace;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.panel-card h3 {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  color: #f8fafc;
  font: 700 24px/1.1 Georgia, serif;
}

.panel-icon,
.button-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.panel-icon {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.06);
}

.panel-icon svg,
.button-icon svg {
  width: 16px;
  height: 16px;
  stroke: currentColor;
  fill: none;
  stroke-width: 1.7;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.panel-card p,
.panel-list li {
  color: rgba(226, 232, 240, 0.76);
  font-size: 14px;
  line-height: 1.7;
}

.panel-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  min-height: 48px;
  margin-bottom: 10px;
  border: 0;
  border-radius: 16px;
  background: linear-gradient(135deg, #f4f4f5, #757b85);
  color: #050505;
  font: 700 13px/1 "Trebuchet MS", "Arial Black", sans-serif;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.button-icon {
  width: 24px;
  height: 24px;
}

.panel-action.ghost {
  margin-bottom: 0;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.03);
  color: #f8fafc;
}

.panel-list {
  display: grid;
  gap: 10px;
}

@media (max-width: 560px) {
  .side-panel {
    gap: 12px;
  }

  .panel-card {
    padding: 14px;
    border-radius: 18px;
  }

  .panel-card h3 {
    font-size: 20px;
  }

  .panel-action {
    min-height: 46px;
    border-radius: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GameLeft.vue